import {
  ProductComparisonDrag,
  ProductComparisonDrop,
} from '@vs-shop/commerce-ui/productComparison';

/**
 * How a column of the comparison looks while the shopper is reordering it.
 *
 * Two independent facts, and a column can carry both at once — it is the column
 * in the air AND the pointer is over it — so the section states them as two
 * axes and this is where the tenant's two indices become them.
 */
export const productComparisonDrag = (
  draggingIndex: number | null,
  index: number
): ProductComparisonDrag =>
  draggingIndex === index ? ProductComparisonDrag.LIFTED : ProductComparisonDrag.IDLE;

export const productComparisonDrop = (
  dragOverIndex: number | null,
  index: number
): ProductComparisonDrop =>
  dragOverIndex === index ? ProductComparisonDrop.RECEIVING : ProductComparisonDrop.IDLE;
